import React from "react";
import "./App.css";
import { DefaultView } from "./components/DefaultView";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

function App() {
	return (
		<Router>
			<Routes>
				<Route exact path="/"
					element={ <DefaultView></DefaultView> }>
				</Route>
				<Route exact path="/home"
					element={ <DefaultView></DefaultView> }>
				</Route>
			</Routes>
		</Router>
	);
}

export default App;